import 'vue';
import { VALUE_SPLIT } from '../utils/commonUtil';
export const useFlatOptions = (options, mergedFieldNames) => {
    const flat = (data, path = '') => {
        if (!data.length)
            return [];
        return data.reduce((pre, acc) => {
            const newPath = path
                ? path + VALUE_SPLIT + String(acc[mergedFieldNames.value['value']])
                : String(acc[mergedFieldNames.value['value']]);
            if (!acc[mergedFieldNames.value['children']]?.length) {
                pre.push({
                    ...acc,
                    path: newPath,
                });
            }
            else {
                pre = pre.concat(flat(acc.children, newPath));
            }
            return pre;
        }, []);
    };
    return flat(options);
};
